import axios from 'axios';
import config from '../config/apiConfig';

const authHeaders = () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token no disponible.");
    return { headers: { token } };
};

// ------------------------------------------------------------------
// Proveedores
// ------------------------------------------------------------------

export const obtenerProveedores = async () => {
    const resp = await axios.get(`${config.api_url}/api/proveedores`, authHeaders());
    return resp.data;
};

export const guardarProveedor = async (proveedorData) => {
    const id = proveedorData.id;
    const url = id ? `/api/proveedores/${id}` : '/api/proveedores';
    const method = id ? 'put' : 'post';
    const resp = await axios[method](`${config.api_url}${url}`, proveedorData, authHeaders());
    return resp.data;
};

export const eliminarProveedor = async (id) => {
    const resp = await axios.delete(`${config.api_url}/api/proveedores/${id}`, authHeaders());
    return resp.data;
};

// ------------------------------------------------------------------
// Compras / Recepción
// ------------------------------------------------------------------

export const obtenerCompras = async () => {
    const resp = await axios.get(`${config.api_url}/api/compras`, authHeaders());
    return resp.data;
};

export const obtenerCompra = async (id) => {
    const resp = await axios.get(`${config.api_url}/api/compras/${id}`, authHeaders());
    return resp.data;
};

export const registrarCompra = async (compraData) => {
    const resp = await axios.post(`${config.api_url}/api/compras`, compraData, authHeaders());
    return resp.data;
};
